<template>
    <div class="absence">
        <div class="pt-2 text-white absenceObject selection-off" :class="{ statusPending: status == 0, statusRejected: status == 2, statusAccepted: status == 3, 'rounded-left': roundingObj[0], 'rounded-right': roundingObj[1], hoverObject: showAbsenceData()}" :style="{ left: offset + '%', width: objWidth + '%' }" :value='absence.range_id' @click="showClosePopup">
            <span>{{ type }}</span>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        components: { 
            moment            
        },
        props: {
            absence: Object,
            viewType: Number,
            weekNumber: Number,
            weeks: Array,
            widthWeek: Number,
            currentMonthYear: String,
            employer: Boolean,
            current_profile_id: Number,
        },
        data: function () {
            return {
                objWidth: 0,
                offset: 0,
                roundingObj: [false, false],
                popup: false,
                status: 0,
                type: this.absence.type,
            }
        },
        mounted() {
            if (this.viewType == 0) {
                this.monthView();
            } else if (this.viewType == 1) {
                this.weekView();
            }

            this.status = this.absence.status;
            
            if (!this.showAbsenceData()) this.type = "Verlof";
        },
        watch: {
            absence: {
                handler: function (data) {
                    this.status = data.status;
                },
                deep: true,
            }
        },
        methods: {
            /**
             * 
             * Views
             * 
             */
            weekView() {                
                // Differences
                let diffDays  = moment(this.absence.end_date).diff(moment(this.absence.start_date), 'days') + 1; // +1 because it won't count the current day
                this.roundingObj = [true, true]; // Left and right rounding of absence object
                let daysLeft = this.daysLeft(this.weekNumber);

                // Checking if days in the view that are left, are less, if so swap values
                if (daysLeft < diffDays) {
                    diffDays = daysLeft;
                    this.roundingObj[1] = false;
                }

                // Calculate width and offset
                this.calculateAbsenceWeek(diffDays);
            },
            monthView() {                
                // Left and right rounding of absence object
                this.roundingObj = [true, true]; 
                
                // Differences
                let diffDays  = moment(this.absence.end_date).diff(moment(this.absence.start_date), 'days') + 1; // +1 because it won't count the current day
                let lastWeekOfView = moment(moment(this.currentMonthYear).locale('nl')).locale('nl').endOf('month').week();
                let weekOfEndDate = moment(this.absence.end_date).locale('nl').week();
                let diffWeeks = 0;

                if (lastWeekOfView < weekOfEndDate) {
                    diffWeeks = lastWeekOfView - moment(this.absence.start_date).locale('nl').week();
                } else {
                    diffWeeks = weekOfEndDate - moment(this.absence.start_date).locale('nl').week();
                }

                if (this.absence.view_type == 3 || !this.weeks.includes(moment(this.absence.end_date).locale('nl').week())) {
                    diffDays = this.daysLeftMonth(lastWeekOfView);
                    this.roundingObj[1] = false;
                }

                // Calculate width and offset
                this.calculateAbsenceMonth(diffDays, diffWeeks);
            },
            /**
             * 
             * Calculations
             * 
             */
            calculateAbsenceMonth(diffDays, diffWeeks) {
                let extraLength = (document.getElementById('filtersCB').checked) ? 4.5 : 3.5;
                extraLength += (window.innerWidth < 1140) ? 2.5 : 0;
                // Width and offset of the absence object
                this.calculateAbsence(diffDays, extraLength, diffWeeks);
                let startView = moment(moment(moment(this.currentMonthYear).locale('nl')).locale('nl').startOf('month')).startOf("isoWeek");

                // If absence is whole month
                if (this.absence.view_type == 1) {
                    this.offset = 0;
                    diffWeeks = moment(this.absence.end_date).locale('nl').week() - moment(startView).locale('nl').week() - 1;
                    this.objWidth = (100 * this.weeks.length) + (extraLength * diffWeeks);
                    this.roundingObj = [false, false];
                // If absence is ending this week
                } else if (this.absence.view_type == 2) {
                    this.offset = 0;
                    let days = moment(this.absence.end_date).diff(moment(startView), 'days') + 1;
                    diffWeeks = moment(this.absence.end_date).locale('nl').week() - moment(startView).locale('nl').week();
                    this.objWidth = ((this.widthWeek / 7) * days) / this.widthWeek * 100 + (extraLength * diffWeeks);
                    this.roundingObj[0] = false;
                }

                this.calculateWidth();
                this.calculateOffset();
            },
            calculateAbsenceWeek(diffDays) {
                // Width and offset of the absence object
                this.calculateAbsence(diffDays);

                // If absence is whole week
                if (this.absence.view_type == 1) {
                    this.offset = 0;
                    this.objWidth = 100; // 100%
                    this.roundingObj = [false, false];
                // If the absence is ending this week
                } else if (this.absence.view_type == 2) {
                    this.offset = 0;
                    let startOfWeek = moment().locale('nl').startOf("isoWeeks").week(this.weekNumber).format("Y-MM-DD");
                    let days = moment(this.absence.end_date).diff(moment(startOfWeek), 'days') + 1;
                    this.objWidth = ((this.widthWeek / 7) * days) / this.widthWeek * 100;
                    this.roundingObj[0] = false;
                }

                // Offset and width changes with on weekview
                this.offset += 0.5;
                this.objWidth -= 1;

                this.calculateWidth();
                this.calculateOffset();
            },
            calculateWidth() {
                let startTime = moment('09:00', 'HH:mm');
                let endTime = moment(this.absence.end_time, 'HH:mm');
                
                let diff = moment.duration(endTime.diff(startTime)).hours()
                let percentage = diff / 8 * 100;

                if (Math.abs(percentage - 75) <= 12.5) {
                    this.objWidth -= 3;
                } else if (Math.abs(percentage - 50) <= 12.5) {
                    this.objWidth -= 6;
                } else if (Math.abs(percentage - 25) <= 12.5) {
                    this.objWidth -= 9;
                }
            },
            calculateOffset() {
                let startTime = moment('09:00', 'HH:mm');
                let endTime = moment(this.absence.start_time, 'HH:mm');
                
                let diff = moment.duration(endTime.diff(startTime)).hours()
                let percentage = diff / 8 * 100;

                if (Math.abs(percentage - 75) <= 12.5) {
                    this.offset += 9;
                    this.objWidth -= 9;
                } else if (Math.abs(percentage - 50) <= 12.5) {
                    this.offset += 6;
                    this.objWidth -= 6;
                } else if (Math.abs(percentage - 25) <= 12.5) {
                    this.offset += 3;
                    this.objWidth -= 3;
                }
            },
            calculateAbsence(diffDays, extraLength = 0, diffWeeks = 0) {
                // Width and offset of the absence object
                this.objWidth = ((this.widthWeek / 7) * diffDays) / this.widthWeek * 100 + (extraLength * diffWeeks);
                this.offset = ((this.widthWeek / 7) * (moment(this.absence.start_date).locale('nl').isoWeekday() - 1)) / this.widthWeek * 100;
            },
            daysLeft(week) {
                // Check how many day's are left in the week. If the absence it longer, add to end of week               
                let lastDayView = moment(this.currentMonthYear).locale('nl').endOf("isoWeek").week(week).format("Y-MM-DD");
                return moment(lastDayView).diff(this.absence.start_date, 'days') + 1; // +1 because it won't count the current day
            },
            daysLeftMonth(lastWeekOfView) {
                // Check how many day's are left in the month. If the absence it longer, add to end of week               
                return this.daysLeft(lastWeekOfView);        
            },
            /**
             * 
             * Events
             * 
             */
            showClosePopup() {
                this.$emit('popup-open', this.absence);
                this.popup = !this.popup;
            },
            setStatus(status) {
                this.$emit('change-status', Number(status));
            },
            changeNotCharged(notCharged) {
                this.absence.notcharged = notCharged;
            },
            /**
             * 
             * Checks
             * 
             */
            showAbsenceData() {
                return (this.employer || this.current_profile_id == this.absence.profile_id) ? true : false;
            }
        },
    }
</script>